const KNOWN_DOMAIN = {
    dev: true,
    beta: true,
    kappa: true,
    stage: true
};

const STORE_SET = {
    shutterfly: 'SFLY',
    tinyprints: 'TP'
};

export default class StoreUtil {

    /**
     * Get Env by host
     * @returns {*}
     */
    static getCurrentEnv() {
        return this._getEnvByHost(StoreUtil._identifyHost());
    }

    /**
     * Get window host
     * @returns {string}
     * @private
     */
    static _identifyHost() {
        return window.location.host;
    }

    /**
     * Get Env name by host
     * @param host
     * @returns {*}
     * @private
     */
    static _getEnvByHost(host) {
        if (!host)
        {return 'production';}

        if (this._isIPAddress(host)) {
            return 'dev';
        }

        const subdomain = this._getSubdomain(host);

        if (subdomain && KNOWN_DOMAIN[subdomain]) {
            return subdomain;
        } else {
            return 'production';
        }
    }

    /**
     * Return true if host is an IP address
     * @param host
     * @returns {*|Array|{index: number, input: string}}
     * @private
     */
    static _isIPAddress(host) {
        return host.match(/^\d+\.\d+\.\d+\.\d+$/);
    }

    /**
     * Get subdomain by host
     * @param host
     * @returns {*}
     * @private
     */
    static _getSubdomain(host) {
        const hostTokens = host.split('.');

        if (hostTokens.length > 1) {
            for (let i = 1, max = hostTokens.length; i < max; i++) {
                if (hostTokens[i].toLowerCase() === 'shutterfly' ||
                    hostTokens[i].toLowerCase() === 'tinyprints') {
                    return hostTokens[i - 1].toLowerCase();
                }
            }
        }

        return undefined;
    }

    /**
     * Get cookie by name
     * @param cookieName
     * @returns {string|*|XML|void}
     */
    static getCookieValue(cookieName) {
        return document.cookie.replace(new RegExp(`(?:(?:^|.*;\\s*)${cookieName}\\s*=\\s*([^;]*).*$)|^.*$`), '$1');
    }

    /**
     * Returns true if product is legacy Pip product
     * @param sizeId
     * @returns {boolean}
     */
    static isLegacyPipProduct(sizeId) {
        const legacyPipProducts = window.legacyPipProductList || [];
        return legacyPipProducts.indexOf(`size_${sizeId}`) >= 0;
    }

    /**
     * Returns true if current page is in TP site
     * @returns {boolean|*|Boolean}
     */
    static isTinyPrint() {
        return document.body.classList.contains('brand-TP') ||
            window.location.host.indexOf('tinyprints.com') > -1;
    }

    /**
     * Returns true if using device browser
     * @returns {boolean}
     */
    static isMobileDevice() {
        return window.navigator.userAgent.toLowerCase().indexOf('mobile') !== -1;
    }

    /**
     * Return store set for current site
     * @returns {*}
     */
    static getCurrentStoreSet() {
        return StoreUtil.isTinyPrint() ? STORE_SET.tinyprints : STORE_SET.shutterfly;
    }

    /**
     * Return Store Set
     * @param name
     * @returns {*}
     */
    static getStoreSet(name) {
        return STORE_SET[name];
    }

    /**
     * Return the current appcode name
     */
    static getCurrentEnvAppCodeName() {
        if(this.getCurrentEnv() === 'production') {
            return 'https://www.shutterfly.com';
        } else {
            return `https://www.${this.getCurrentEnv()}.shutterfly.com`;
        }
    }

    static getCurrentEnvCookieKey() {
        return `visitor${this.getCurrentEnv() ? `_${this.getCurrentEnv()}` : ''}`;
    }
}
